export enum CancelMode { Reserve, Segment }